var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-tabs"
  }, _vm._l(_vm.tabs, function (tab) {
    return _c('router-link', {
      key: tab.order,
      staticClass: "s-tab",
      class: {
        'active-tab': _vm.currentTab && (_vm.currentTab === tab.id || _vm.currentTab === tab.path)
      },
      attrs: {
        "to": {
          path: tab.path || tab.provider,
          query: Object.assign({}, _vm.$route.query, tab.query || {})
        }
      }
    }, [_vm._v(" " + _vm._s(tab.type_name) + " ")]);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }